var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmbassador(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 34,
    viewBox: "0 0 25 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0115 14.6159C23.2016 10.9254 22.6997 8.27782 22.6997 8.27782C22.0983 5.44812 19.4205 3.65817 17.0445 3.32941C14.6293 2.99376 12.518 2.22559 12.518 2.22559C12.518 2.22559 10.4073 2.99376 7.99156 3.32941C5.61609 3.65817 2.93779 5.44812 2.33638 8.27782C2.33638 8.27782 1.80591 11.0456 1.99597 14.7356C1.85779 15.3889 0.873617 18.2731 3.16756 18.9534C3.16756 18.9534 4.5075 19.5644 7.50556 17.3371C7.50556 17.3371 9.25156 16.0072 12.4963 16.0072C15.7411 16.0072 17.4866 17.3371 17.4866 17.3371C20.3893 19.6967 21.8251 18.9534 21.8251 18.9534C24.1201 18.2736 23.1497 15.2698 23.0115 14.6159Z",
    stroke: "#394553",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90173 15.2442C1.90173 15.2442 10.844 6.74501 23.0999 15.0038",
    stroke: "#394553",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6693 28.4199C11.842 28.9059 13.1602 28.9059 14.3323 28.4199",
    stroke: "#394553",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49992 17.6279C1.49992 17.6279 -1.19796 20.879 2.70645 23.5261C2.70645 23.5261 4.21263 33.4838 12.5011 33.4838C20.7896 33.4838 22.2957 23.5261 22.2957 23.5261C26.2002 20.879 23.5017 17.6279 23.5017 17.6279",
    stroke: "#394553",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1967 2.5682H10.8053V2.20608C10.8053 1.44796 11.5502 0.854492 12.5005 0.854492C13.4513 0.854492 14.1967 1.44796 14.1967 2.20608V2.5682Z",
    fill: "#394553"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18367 22.4735C8.77692 22.4735 9.25785 21.9926 9.25785 21.3994C9.25785 20.8061 8.77692 20.3252 8.18367 20.3252C7.59042 20.3252 7.1095 20.8061 7.1095 21.3994C7.1095 21.9926 7.59042 22.4735 8.18367 22.4735Z",
    fill: "#394553"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.819 22.4735C17.4122 22.4735 17.8932 21.9926 17.8932 21.3994C17.8932 20.8061 17.4122 20.3252 16.819 20.3252C16.2257 20.3252 15.7448 20.8061 15.7448 21.3994C15.7448 21.9926 16.2257 22.4735 16.819 22.4735Z",
    fill: "#394553"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbassador);
export default __webpack_public_path__ + "static/media/ambassador.b29c4a67fef70a878a79a13dddf1ba1a.svg";
export { ForwardRef as ReactComponent };